import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, StyleValue} from "vue";

interface Props {
  inline?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RowEnd',
  props: {
    inline: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const rowFlexStyle = computed<StyleValue>(() => {
  if (props.inline) {
    return {
      display: 'flex',
      flexWrap: 'inherit',
      gap: 'inherit',
      alignItems: 'inherit',
    };
  }
  return {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "ml-auto",
    style: _normalizeStyle(rowFlexStyle.value)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4 /* STYLE */))
}
}

})